
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7925"}},[_c('g',{attrs:{"data-name":"Group 5927"}},[_c('g',{attrs:{"data-name":"Group 5926","transform":"translate(6 5)","fill":"none","stroke":"#109a50","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Path 7790","d":"M8.573 25.247h0a2.88 2.88 0 002.881 2.881h1.44a2.88 2.88 0 002.881-2.881h0a2.88 2.88 0 00-2.881-2.881h0a2.88 2.88 0 002.881-2.881h0a2.88 2.88 0 00-2.881-2.881h-1.44a2.88 2.88 0 00-2.881 2.881h0"}}),_c('rect',{attrs:{"data-name":"Rectangle 4007","width":"33","height":"27","rx":"1","transform":"translate(0 6)"}}),_c('path',{attrs:{"data-name":"Line 96","d":"M0 12h33"}}),_c('path',{attrs:{"data-name":"Line 97","d":"M27 0v8"}}),_c('path',{attrs:{"data-name":"Line 98","d":"M6 0v8"}}),_c('path',{attrs:{"data-name":"Path 7791","d":"M22.976 28.128V16.605l-2.881 2.881"}})])]),_c('path',{attrs:{"data-name":"Rectangle 4208","fill":"none","d":"M0 0h44v44H0z"}})])])
          )
        }
      }
    